define('paymentintentcreation.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('paymentintentcreation', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n";
},"useData":true}, 'extensions/MHI/StripeCustomization/2.0.7/', 'extensions/MHI/StripeCustomization/2.0.7/', Handlebars);
});